import type { TableHeadProps as ChakraTableHeadProps } from '@chakra-ui/react';
import { Thead as ChakraThead } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type TableHeadProps = OmitChakraProps<ChakraTableHeadProps>;

export const Thead = withChakraAs<TableHeadProps, 'thead'>((props) => {
  return <ChakraThead {...props} />;
});
